import { render, staticRenderFns } from "./AppButtonAddFailureTracking.vue?vue&type=template&id=e7d8b396&scoped=true&"
import script from "./AppButtonAddFailureTracking.vue?vue&type=script&lang=ts&"
export * from "./AppButtonAddFailureTracking.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7d8b396",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
